import { AT } from '../../../actions/actionTypes';
import { RequestState, Transfer } from './model';
import { RequestStateDefault } from './defaults';
import { PKey } from '../../devices';
import * as TxReducer from './transfer.reducer'
import Logger from '../../../libs/logger';  import { LogArea } from '../../../libs/logger/const';

const defaultState: RequestState = RequestStateDefault;

export const updateTransfer = (
  state = defaultState,
  transfer: Transfer
): RequestState => ({
  ...state,
  transfer,
});

export const updateDevices = (
  state = defaultState,
  devices: PKey[]
): RequestState =>
  updateTransfer(state, TxReducer.setDevices(state.transfer, devices));


export default function (state = defaultState, action: any) {
  switch (action.type) {
    case AT.DIALOG_TRANSFER_REQUEST_UPDATE_TRANSFER: {
      Logger.info(
        [AT.DIALOG_TRANSFER_REQUEST_UPDATE_TRANSFER, action],
        LogArea.Redux
      );
      const {transfer, validateCall, createCall}: RequestState = action.payload;
      return {...state, transfer, validateCall, createCall};
    }

    default: {
      return state;
    }
  }
}
